import Empty from '@/images/empty/good.png'
import Cart from '@/images/empty/cart.png'
import Coupon from '@/images/empty/coupon.png'
import Offine from '@/images/empty/offline.png'
import ServerError from '@/images/empty/server_error.png'
import Search from '@/images/empty/search.png'
import OrderList from '@/images/empty/order.png'
import DefaultEmpty from '@/images/empty/empty.png'
const EmptyImage = {
  Empty,
  Cart,
  Coupon,
  Offine,
  ServerError,
  Search,
  OrderList,
  DefaultEmpty
}

export { EmptyImage }
